import { Alignment } from "@faire/web-api--source/indigofair/data/Alignment";

export const getCssAlignmentValue = (
  key?: keyof typeof Alignment,
  defaultValue: "flex-start" | "center" | "flex-end" = "flex-start"
) => {
  switch (key) {
    case Alignment.ALIGNMENT_START:
      return "flex-start";
    case Alignment.ALIGNMENT_CENTER:
      return "center";
    case Alignment.ALIGNMENT_END:
      return "flex-end";
    default:
      return defaultValue;
  }
};
